// extracted by mini-css-extract-plugin
module.exports = {"signuptext":"Login_signuptext__1btHm","forgetpwdtext":"Login_forgetpwdtext__d3rs6"};